import { type ReactNode } from 'react';
import {
    isValidPassword,
    isNonEmpty,
    isValidPasswordLength,
    isValidPasswordNumberOrCharacter,
    isValidPasswordLetter,
} from '../../helpers/validators';
import authCopy from '../authCopy';

const { errors } = authCopy;

export const validationErrorCodes = {
    TOO_SHORT: 'TO_SHORT',
    NUMBER_OR_SPECIAL_CHARACTER: 'NUMBER_OR_SPECIAL_CHARACTER',
    LETTER: 'LETTER',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function validatePassword(password: any): ReactNode {
    if (!isNonEmpty(password)) {
        return errors.passwordRequired;
    } else if (!isValidPassword(password)) {
        return errors.passwordShort;
    }
    return null;
}

export const getPasswordErrorCodes = (password: string): Record<string, boolean> => ({
    [validationErrorCodes.TOO_SHORT]: !isValidPasswordLength(password),
    [validationErrorCodes.NUMBER_OR_SPECIAL_CHARACTER]: !isValidPasswordNumberOrCharacter(password),
    [validationErrorCodes.LETTER]: !isValidPasswordLetter(password),
});

export const hasPasswordError = (errorCodes: Record<string, boolean> | null): boolean =>
    Object.values(errorCodes || {}).some(errorCode => errorCode);

export const getPasswordErrorCodesAndMatch = (
    password: string,
    passwordConf: string
): { password: Record<string, boolean>; passwordConf: ReactNode | null } => ({
    password: getPasswordErrorCodes(password),
    passwordConf: password !== passwordConf ? errors.passwordMatch : null,
});

export const hasPasswordOrMatchError = (validationErrors: {
    password: Record<string, boolean> | null;
    passwordConf: string | null;
}): boolean => hasPasswordError(validationErrors?.password) || !!validationErrors?.passwordConf;

export const getPasswordErrorCodesString = (password: string): string | null => {
    if (!isNonEmpty(password)) {
        return 'Password is required.';
    } else if (hasPasswordError(getPasswordErrorCodes(password))) {
        return 'Password requirements error.';
    }
    return null;
};
